import { repository } from "~/repository";
import { baseProducts, ProductTypes } from "~/types";
import { forEach, filter } from "lodash-es";
import getSymbolFromCurrency from "currency-symbol-map";

export function useProductInfo() {
  const { data: products, pending } = useAsyncData(
    () => repository.common.fetchProducts(),
    {
      lazy: true,
      transform: ({ data }) => {
        const tempProducts = { ...baseProducts };

        forEach(data, (el) => {
          tempProducts[el.type] = {
            ...tempProducts[el.type],
            paypal_product_id: el?.paypal_product_id,
            stripe_product_id: el?.stripe_product_id,
            property_id: el?.property_id,
            symbol: getSymbolFromCurrency(el?.price?.currency || "USD") || "$",
          };
        });

        tempProducts[ProductTypes.TRAINING_ANNUAL].highlighted = true;

        return filter(Object.values(tempProducts), {
          isDiscountedPlan: false,
        });
      },
    },
  );

  return {
    products,
    pending,
  };
}
